var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotGroup)?_c('span',[_c('v-icon',{staticStyle:{"font-size":"20px"},attrs:{"color":"primary"},on:{"click":function($event){return _vm.controlClick($event)}}},[_vm._v("mdi-delete-outline")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }